// Tabbed Content functionality
const tabbedContentBlocks = document.querySelectorAll('.wp-block-pulp-tabbed-content');
const FADE_DURATION = 400; // Match CSS transition duration

tabbedContentBlocks.forEach((block) => {
    const tabButtons = block.querySelectorAll('.tab-button');
    const tabPanels = block.querySelectorAll('.tab-panel');
    let isAnimating = false;

    tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const tabIndex = parseInt(button.dataset.tabIndex, 10);
            const currentActivePanel = block.querySelector('.tab-panel.is-active');
            const newPanel = tabPanels[tabIndex];

            // Don't do anything if clicking the already active tab or animating
            if (currentActivePanel === newPanel || isAnimating) return;

            isAnimating = true;

            // Update buttons immediately
            tabButtons.forEach((btn) => {
                btn.classList.remove('is-active');
                btn.setAttribute('aria-selected', 'false');
            });
            button.classList.add('is-active');
            button.setAttribute('aria-selected', 'true');

            // Fade out current panel
            if (currentActivePanel) {
                currentActivePanel.classList.add('is-fading-out');
                currentActivePanel.classList.remove('is-active');
            }

            // Fade in new panel
            newPanel.classList.add('is-fading-in');
            newPanel.removeAttribute('hidden');

            // After transition, clean up classes
            setTimeout(() => {
                if (currentActivePanel) {
                    currentActivePanel.classList.remove('is-fading-out');
                    currentActivePanel.setAttribute('hidden', '');
                }
                newPanel.classList.remove('is-fading-in');
                newPanel.classList.add('is-active');
                isAnimating = false;
            }, FADE_DURATION);
        });

        // Keyboard navigation
        button.addEventListener('keydown', (e) => {
            const currentIndex = parseInt(button.dataset.tabIndex, 10);
            let newIndex;

            if (e.key === 'ArrowRight') {
                newIndex = currentIndex + 1;
                if (newIndex >= tabButtons.length) newIndex = 0;
            } else if (e.key === 'ArrowLeft') {
                newIndex = currentIndex - 1;
                if (newIndex < 0) newIndex = tabButtons.length - 1;
            } else if (e.key === 'Home') {
                newIndex = 0;
            } else if (e.key === 'End') {
                newIndex = tabButtons.length - 1;
            }

            if (newIndex !== undefined) {
                e.preventDefault();
                tabButtons[newIndex].click();
                tabButtons[newIndex].focus();
            }
        });
    });
});

// Gallery modal triggers
const galleryTriggers = document.querySelectorAll('.gallery-trigger');

galleryTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
        const modalId = trigger.dataset.modalTarget;
        const modal = document.getElementById(modalId);
        
        if (modal) {
            modal.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            
            // Focus the close button
            const closeBtn = modal.querySelector('.modal-close');
            if (closeBtn) {
                setTimeout(() => closeBtn.focus(), 100);
            }
        }
    });
});

// Gallery modal close
document.querySelectorAll('.gallery-modal').forEach((modal) => {
    // Close button and overlay clicks
    modal.querySelectorAll('[data-a11y-dialog-hide]').forEach((closeEl) => {
        closeEl.addEventListener('click', () => {
            modal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        });
    });

    // Escape key
    modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            modal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        }
    });
});

